import React from "react";
import { signalLabel } from "../utils/format";

export function StatusBadge({ status }) {
  return (
    <span className={`badge rounded-pill status-badge bg-light-${status.key} text-${status.key}`}>
      <i className={`${status.icon} me-1`}></i>
      {status.label}
    </span>
  );
}

export function SignalBars({ rssi }) {
  const { label, bars } = signalLabel(rssi);
  return (
    <span className="signal-bars" title={rssi == null ? "No signal data" : `${rssi} dBm`}>
      <svg width="16" height="12" viewBox="0 0 16 12" aria-hidden="true">
        {[0, 1, 2, 3].map((i) => (
          <rect key={i} x={i * 4} y={9 - i * 3} width="3" height={3 + i * 3} rx="1" className={i < bars ? "bar-on" : "bar-off"} />
        ))}
      </svg>
      {label}
    </span>
  );
}

export function BatteryLevel({ pct, low }) {
  if (pct == null) return <span className="text-muted">—</span>;
  return (
    <span className={`battery-level ${low ? "is-low" : ""}`} title={`${pct}%`}>
      <i className={`ti ${pct > 60 ? "ti-battery-3" : pct > 30 ? "ti-battery-2" : "ti-battery-1"}`}></i>
      {pct}%
    </span>
  );
}
